/**
 * Plan limits
 *
 * Only the `free` plan is limited; `trial` and `pro` are unrestricted.
 */
export const FREE_PLAN_LIMITS = {
    maxFolders: 3, // active (monitored) folders
    maxFiles: 10, // latest updated files shown per folder
    dailySyncLimit: 10, // folder syncs per day across all folders
} as const

export const TRIAL_DAYS = 14
